<div class="loader-icon" *ngIf="loaderService.visible">
  <div class="icon-holder white-container-box">
    <img src="assets/img/branding/loader-icon.gif" alt="Loader">
  </div>
</div>
